import { useState, useEffect } from 'react'
import * as API from '../lib/JerseyDirectoryAPI'

function UsePendingList() {

    const [listings, setListings] = useState([]);
    const [selectedRecords, setSelectedRecords] = useState([]);
    const [selectedListing, setSelectedListing] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3;


    const paginatedResults = listings.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const totalPages = Math.ceil(listings.length / itemsPerPage);


    useEffect(() => {
        // Fetch data from the API
        API.getPendingListings()
            .then(response => {
                setListings(response.data);
                setCurrentPage(1);
            })
            .catch(error => {
            });
    }, []);

    const handleCheckboxChange = (ID) => {
        setSelectedRecords(prevSelectedRecords =>
            prevSelectedRecords.includes(ID)
                ? prevSelectedRecords.filter(recordId => recordId !== ID)
                : [ID] // Allow only one selection at a time
        );
    };

    const handleSelectClick = () => {
        const selected = listings.find(listing => listing.ID === selectedRecords[0]);
        setSelectedListing(selected);
    };

    const handleDeletePendingListing = async (listingId) => {
        try {
            await API.deletePendingDirectoryListing(listingId, selectedListing);
            // Update listings after successful deletion
            setListings(prevListings => prevListings.filter(listing => listing.ID !== listingId));
            setSelectedRecords([]);
            setSelectedListing(null);
        } catch (error) {
        }
    };

    return {
        listings,
        selectedRecords,
        selectedListing,
        currentPage,
        itemsPerPage,
        paginatedResults,
        totalPages,
        handleCheckboxChange,
        handleSelectClick,
        setCurrentPage,
        handleDeletePendingListing
    }
}

export default UsePendingList;
